import VerticalPage from "@/components/VerticalPage";
import { Stack } from "@phosphor-icons/react";

export default function PrivateFunds() {
  return (
    <VerticalPage
      eyebrow="Portfolio · Private Funds"
      title="Private Funds"
      subtitle="LP interests, capital calls, and distributions across closed-end vehicles."
      IconLg={Stack}
      assetType="private_equity_lp"
    />
  );
}
